import React, { FunctionComponent } from 'react';

// Transalte
import { Translate } from 'react-localize-redux';

// Styled
import styled from 'styled-components';

// Components
import Flex from '@components/layout/flex';
import Grid from '@components/basics/grid';
import Typography from '@components/basics/typography';

// Filters
import DSPsFilter from './dsps-filter';
import DateRangeFilter from './daterange-filter';
import { useDispatch } from 'react-redux';
import {
  UpdateAnalyticsTimeframe,
  UpdateField,
} from '@webapp/store/artist-analytics/action-creators';
import moment from 'moment';

interface AnalyticsMenuContentProps {
  className?: string;
  analyticsRange: string;
  analyticsDsps: string[];
  onDateRangeFilterChange: (value: string) => void;
  onDspsFilterChange: (value: string[]) => void;
}

const AnalyticsMenuContent: FunctionComponent<AnalyticsMenuContentProps> = ({
  className,
  analyticsRange,
  analyticsDsps,
  onDateRangeFilterChange,
  onDspsFilterChange,
}) => {
  const dispatch = useDispatch();
  // TODO: DEVTEAM-405 - Integrate handleClearFilters.
  const handleClearFilters = () => {
    let start: number = 0;
    let end: number = 0;
    start = moment().subtract(1, 'months').unix();
    end = moment().unix();
    dispatch(new UpdateField('dsps', []));
    dispatch(new UpdateField('range', 'lastMonth'));
    dispatch(new UpdateField('days', '30'));
    dispatch(new UpdateAnalyticsTimeframe(start, end));
    return;
  };

  return (
    <Content className={className || ''}>
      <Header justifyContent="space-between" alignItems="center">
        <Typography weight="700">
          <Translate id="ANALYTICS.MENU.TITLE" />
        </Typography>
        <Typography className="clear-link" onClick={handleClearFilters}>
          <Translate id="ANALYTICS.MENU.CLEAR" />
        </Typography>
      </Header>
      <Grid gap={20}>
        <DateRangeFilter
          analyticsRange={analyticsRange}
          onDateRangeFilterChange={onDateRangeFilterChange}
        />
        <DSPsFilter
          analyticsDsps={analyticsDsps}
          onDspsFilterChange={onDspsFilterChange}
        />
        {/* <CountriesFilter />
        <ReleasesFilter /> */}
      </Grid>
    </Content>
  );
};

export default AnalyticsMenuContent;

const Content = styled.div`
  height: 100%;
`;

const Header = styled(Flex)`
  padding-bottom: 30px;

  .clear-link {
    cursor: pointer;
    color: ${({ theme }) => theme.colors.tertiary};
    transition: color
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};

    &:hover {
      color: ${({ theme }) => theme.colors.accent};
    }
  }
`;
